import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';
import { TranslationFuncProp } from '../../../common/types/prop-types/common';
import iconCancelar from '../../assets/images/icons/Cinzentos/cancelar.svg';
import iconLapisEditar from '../../assets/images/icons/Cinzentos/lapisEditar.svg';
import DataAccessContainer, { DataAccessContainerProps, DataAccessProps } from './containers/DataAccessContainer';
// import DeleteAccount from './DeleteAccount';

const ReadState: React.FC<DataAccessProps & TranslationFuncProp> = (props) => {
    if (props.editState.isEditing) {
        return null;
    }
    return (
        <React.Fragment>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-email', 'label-space'])}>{props.t('common:brandId')}</label>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <span>{props.email.inputProps.value}</span>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-cadeado', 'label-space'])}>{props.t('common:password')}</label>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <span>********</span>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
        </React.Fragment>
    );
};

const EditState: React.FC<DataAccessProps & TranslationFuncProp> = (props) => {
    if (!props.editState.isEditing) {
        return null;
    }
    return (
        <React.Fragment>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-cadeado', 'label-space'])}>{props.t('common:password')}</label>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <div>
                    <label className={'label-space'}>{props.t('profile:changePassword.oldPassword')}</label>
                    <input {...props.oldPassword.inputProps} type="password" className={classNames(['has-tip', 'bottom'])} aria-haspopup="true" data-disable-hover="false" data-tooltip="9r4d88-tooltip" title="" data-position="bottom" data-alignment="center" aria-describedby="o7qw2l-tooltip" data-yeti-box="o7qw2l-tooltip" data-toggle="o7qw2l-tooltip" data-resize="o7qw2l-tooltip" />
                    {props.oldPassword.errorText && <div className="error-message">{props.oldPassword.errorText}</div>}
                </div>
                <div>
                    <label className={'label-space'}>{props.t('signup:formFields.password')}</label>
                    <input {...props.password.inputProps} type="password" className={classNames(['has-tip', 'bottom'])} aria-haspopup="true" data-disable-hover="false" data-tooltip="iykvrh-tooltip" title="" data-position="bottom" data-alignment="center" aria-describedby="i40htv-tooltip" data-yeti-box="i40htv-tooltip" data-toggle="i40htv-tooltip" data-resize="i40htv-tooltip" />
                    {props.password.errorText && <div className="error-message">{props.password.errorText}</div>}
                </div>
                <div>
                    <label className={'label-space'}>{props.t('profile:changePassword.passwordConfirm')}</label>
                    <input {...props.passwordConfirm.inputProps} type="password" className={classNames(['has-tip', 'bottom'])} aria-haspopup="true" data-disable-hover="false" data-tooltip="r43f6y-tooltip" title="" data-position="bottom" data-alignment="center" aria-describedby="qf38jk-tooltip" data-yeti-box="qf38jk-tooltip" data-toggle="qf38jk-tooltip" data-resize="qf38jk-tooltip" />
                    {props.passwordConfirm.errorText && <div className="error-message">{props.passwordConfirm.errorText}</div>}
                </div>
                <p>{props.t('signup:passwordReq.header')}</p>
                <ul>
                    <li>{props.t('signup:passwordReq.content1')}</li>
                    <li>{props.t('signup:passwordReq.content2')}</li>
                    <li>{props.t('signup:passwordReq.content3')}</li>
                    <li>{props.t('signup:passwordReq.content4')}</li>
                    <li>{props.t('signup:passwordReq.content5')}</li>
                </ul>
                {props.submitErrorText && <div className="error-message">{props.submitErrorText}</div>}
                <div className={classNames(['small', 'button-group', 'dados-pacotes'])}>
                    <button className={classNames(['button', 'alterar'])} {...props.btnEditDataAccess}>{props.btnEditDataAccess.disabled ? props.t('loadingText') : props.t('change')}</button>
                    <button className={classNames(['button', 'cancelar', 'margin-left-1'])} onClick={props.editState.changeEditMode}>{props.t('cancel')}</button>
                </div>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
        </React.Fragment>
    );
};

const DataAccess: React.FC<DataAccessContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    return (
        <DataAccessContainer {...containerProps} t={t} >
            {(props: DataAccessProps) => {
                return (
                    <React.Fragment>
                        <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns', 'edit-area'])}>
                            <div className={'edit-area'}>
                                <p className={classNames(['margin-left-0', 'margin-top-1', 'float-left'])}>{t('profile:canEdit')}</p>
                                <div className={classNames(['tabs-title', 'float-right'])}>
                                    <a onClick={props.editState.changeEditMode}>
                                        <img src={props.editState.isEditing ? iconCancelar : iconLapisEditar} alt={props.editState.isEditing ? t(`common:cancel`) : t(`common:edit`)} />
                                        {props.editState.isEditing ? t(`common:cancel`) : t(`common:edit`)}
                                    </a>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                            <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                                <div className={classNames(['tabs-panel', 'is-active'])} id="dados-pessoais">
                                    <div className={classNames(['grid-container', 'fluid'])}>
                                        <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                            <EditState
                                                t={t}
                                                {...props}
                                            />
                                            <ReadState
                                                t={t}
                                                {...props}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* !props.editState.isEditing && <DeleteAccount /> */}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }}
        </DataAccessContainer>
    );
};

export default DataAccess;
